export function defineComparer(object) {
  if (object.name) return 'byName'
  if (object.shortName) return 'byShortName'
  if (object.id) return 'byId'
}

export function byShortName(a, b) {
  let comparison = 0
  if (a.shortName > b.shortName) {
    comparison = 1
  } else if (a.shortName < b.shortName) {
    comparison = -1
  }
  return comparison
}

export function byName(a, b) {
  let comparison = 0
  if (a.name > b.name) {
    comparison = 1
  } else if (a.name < b.name) {
    comparison = -1
  }
  return comparison
}

export function byID(a, b) {
  let comparison = 0
  if (a.id > b.id) {
    comparison = 1
  } else if (a.id < b.id) {
    comparison = -1
  }
  return comparison
}
